import styled from "styled-components";
import { ButtonStyled } from "../../components/Button/Button.styled";

export const PictureError = styled.svg``;

export const TextError = styled.p`
  font-size: 25px;
  font-weight: 500;
`;

export const ButtonErrorStyled = styled(ButtonStyled)`
  padding: 14px 18px;

  font-size: 20px;
`;

export const ErrorWrapperStyled = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
`;
